import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '../css/app.scss';

Vue.use(Vuetify);

export default new Vuetify({
});
